

































import { Component, Watch, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import MenuItem from '@/components/menu/menu-item.vue';
import { mixins } from 'vue-class-component';
import MenuDropdown from '@/components/menu-dropdown.vue';
import BookmarkAdd from '@/components/bookmark/bookmark-add.vue';

import ReportTabsMixin from '@/views/reports/views/mixins/report-tabs-mixin';
import MainMenuReportTabsMobileItem from '@/views/layout/navigation/grouping/main-menu-report-tabs-mobile-item.vue';

@Component({
  components: {
    MenuItem,
    MenuDropdown,
    BookmarkAdd,
    MainMenuReportTabsMobileItem
  }
})
export default class MainMenuReportTabsMobileDropdown extends mixins(ReportTabsMixin) {
  handleMainSelectClick() {
    this.close();
  }

  handleAction(tab: any, event: any) {
    if(tab.click) {
      tab.click(event);
    }

    this.close();
  }

  handleClose(redirect: boolean) {
    if(redirect) {
      this.close();
    }
  }

  handleClickOutside() {
    if(this.$store.state.mobile.menuReportTabsOpen) {
      this.close();
    }
  }

  close() {
    this.$store.commit('mobileMenuReportTabsOpen', false);
  }
}
